import { Injectable } from '@angular/core';
import { B2BConfig, ConfiguratorOptions, Panel } from '@icc/shared/types';

@Injectable({
    providedIn: 'root',
})
export class ConfigService {
    private configuration: B2BConfig;
    private configuratorOpts!: ConfiguratorOptions;
    private _activePanel: Panel;

    set config(config) {
        this.configuration = config;
    }
    get config() {
        return this.configuration;
    }

    set configuratorOptions(options) {
        this.configuratorOpts = options;
    }
    get configuratorOptions() {
        return this.configuratorOpts;
    }

    get user() {
        return this.config?.userData;
    }

    get activePanel() {
        return this._activePanel;
    }
    set activePanel(panel: Panel) {
        if (!this._activePanel) {
            this._activePanel = panel;
        }
    }

    constructor() {}
}
